// Экспортируем объект конфигурации фильтров
export const filtersConfig = {
  staff: [
    {
      field: "rental_point",
      label: "Пункт проката",
      type: "select",
      options: ["Пункт 1", "Пункт 2"],
      isVisible: true,
    },
    {
      field: "position",
      label: "Должность",
      type: "select",
      options: ["Менеджер", "Администратор"],
      isVisible: true,
    },
    {
      field: "status",
      label: "Активность",
      type: "select",
      options: ["Активен", "Уволен"],
      isVisible: true,
    },
  ],
  rent: [
    {
      field: "start_date",
      label: "Дата начала",
      type: "date",
      isVisible: true,
    },
    {
      field: "end_date",
      label: "Дата окончания",
      type: "date",
      isVisible: true,
    },
    {
      field: "status",
      label: "Статус аренды",
      type: "select",
      options: ["Открыта", "Закрыта"],
      isVisible: true,
    },
    {
      field: "payment_type",
      label: "Тип платежа",
      type: "select",
      options: ["Наличные", "Карта"],
      isVisible: true,
    },
  ],
  assets: [
    {
      field: "status",
      label: "Статус",
      type: "select",
      options: [], // Будет заполнено динамически из API
      isVisible: true,
    },
    {
      field: "rental_point.name",
      label: "Пункт проката",
      type: "select",
      options: [], // Будет заполнено динамически из API
      isVisible: true,
    },
    {
      field: "type",
      label: "Тип",
      type: "select",
      options: ["Тип 1", "Тип 2"],
      isVisible: true,
    },
    {
      field: "category",
      label: "Категория",
      type: "select",
      options: ["Категория 1", "Категория 2"],
      isVisible: true,
    },
    {
      field: "created_at",
      label: "Дата создания",
      type: "date",
      isVisible: true,
    },
    {
      field: "updated_at",
      label: "Дата обновления",
      type: "date",
      isVisible: true,
    },
  ],
  clients: [
    {
      field: "show_deleted",
      label: "Удалённые клиенты",
      type: "select",
      options: [
        { value: "false", label: "Скрыть" },
        { value: "true", label: "Только удалённые" },
        { value: "all", label: "Все" },
      ],
      isVisible: true,
    },
    {
      field: "black_list",
      label: "Черный список",
      type: "select",
      options: ["true", "false"],
      isVisible: true,
    },
    {
      field: "attraction_source_id",
      label: "Источник привлечения",
      type: "select",
      options: [], // Будет заполнено динамически из API
      isVisible: true,
    },
    {
      field: "assistant_status",
      label: "Статус ассистента",
      type: "select",
      options: ["0", "1"],
      isVisible: true,
    },
    {
      field: "created_at",
      label: "Дата создания",
      type: "date",
      isVisible: true,
    },
  ],
  rental_deals: [
    {
      field: "start_date",
      label: "Дата начала",
      type: "date",
      isVisible: true,
    },
    {
      field: "end_date",
      label: "Дата окончания",
      type: "date",
      isVisible: true,
    },
    {
      field: "status",
      label: "Статус аренды",
      type: "select",
      options: [
        { value: "в_процессе", label: "В процессе" },
        { value: "просрочена", label: "Просрочена" },
        { value: "закрыта", label: "Закрыта" },
        { value: "отменена", label: "Отменена" },
      ],
      isVisible: true,
    },
    {
      field: "hide_closed",
      label: "Скрыть закрытые и отменённые",
      type: "checkbox",
      options: [],
      isVisible: true,
    },
    {
      field: "client_id",
      label: "Клиент",
      type: "select",
      options: [], // Будет заполнено динамически из API
      isVisible: true,
    },
    {
      field: "asset_id",
      label: "Актив",
      type: "select",
      options: [], // Будет заполнено динамически из API
      isVisible: true,
    },
    {
      field: "created_at",
      label: "Дата создания",
      type: "date",
      isVisible: true,
    },
  ],
};

export default filtersConfig;
